interface WeekendOverlayProps {
  /** Index of the first weekend column (Sa/Su pair) relative to the label column. */
  columnIndex: number;
  /** Width of each day column in pixels (matches the grid `1fr` rendered value). */
  dayWidth: number;
  /** Number of day columns this overlay should span (1 for Sa or Su alone, 2 for a Sat+Sun pair). */
  span: number;
  /** Pixel offset from the left edge of the items area (i.e. after the label column). */
  leftOffset: number;
}

/**
 * Shade Sa/Su columns with the muted background colour. Rendered behind the
 * cards (lower z-index) inside the relative items container.
 */
export function WeekendOverlay({
  columnIndex,
  dayWidth,
  span,
  leftOffset,
}: WeekendOverlayProps) {
  return (
    <div
      aria-hidden
      data-testid="timeline-weekend-overlay"
      className="pointer-events-none absolute top-0 bottom-0 bg-muted/40"
      style={{
        left: leftOffset + columnIndex * dayWidth,
        width: dayWidth * span,
      }}
    />
  );
}
